import { Component, effect, inject } from '@angular/core';
import {
  VbLxpPanelComponent,
  RaceSessionService,
  TimingTowerFullComponent,
  TimingTowerService,
} from '@vbrick/vb-lxp-lib';
import { MiniMapComponent } from './mini-map/mini-map.component';
import { toSignal } from '@angular/core/rxjs-interop';

@Component({
  selector: 'app-full-timing.component',
  imports: [MiniMapComponent, VbLxpPanelComponent, TimingTowerFullComponent],
  templateUrl: './full-timing.component.html',
  styleUrl: './full-timing.component.css',
})
export class FullTimingComponent {
  public timingTowerService = inject(TimingTowerService);
  public raceSessionService = inject(RaceSessionService);
  public selectedClasses = toSignal(this.raceSessionService.selectedClasses$, { initialValue: [] });
}
